import { render, staticRenderFns } from "./AuthSuccess.vue?vue&type=template&id=98e081c4&scoped=true"
import script from "./AuthSuccess.vue?vue&type=script&lang=js"
export * from "./AuthSuccess.vue?vue&type=script&lang=js"
import style0 from "./AuthSuccess.vue?vue&type=style&index=0&id=98e081c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e081c4",
  null
  
)

export default component.exports